import isUndefined from "lodash/isUndefined";

import { createReducer } from "../../../generic/redux/createReducer";
import { pairActionTypeToReducer } from "../../../generic/redux/TypedRedux";

import type { CloseMainMenu, ClosePane, OpenMainMenu, OpenPane } from "./LayoutActions";
import { CLOSE_MAIN_MENU, CLOSE_PANE, OPEN_MAIN_MENU, OPEN_PANE } from "./LayoutActionTypes";
import { type LayoutState, initialLayoutState } from "./LayoutState";

function toggleMainMenuReducer(layoutState: LayoutState, action: CloseMainMenu | OpenMainMenu): LayoutState {
	const open = action.type !== CLOSE_MAIN_MENU;

	if (layoutState.mainMenu.open === open) {
		return layoutState;
	}

	return {
		...layoutState,
		mainMenu: { open },
	};
}

function openPaneReducer(state: LayoutState, action: OpenPane): LayoutState {
	const { location, name } = action;
	return {
		...state,
		activePanes: {
			...state.activePanes,
			[location]: name,
		},
	};
}

const closePaneReducer = (state: LayoutState, { location, name }: ClosePane): LayoutState => {
	const currentPane = state.activePanes[location];
	return {
		...state,
		activePanes: {
			...state.activePanes,
			[location]: isUndefined(name) || currentPane === name ? undefined : currentPane,
		},
	};
};

export default createReducer<LayoutState>(initialLayoutState, {
	...pairActionTypeToReducer(OPEN_MAIN_MENU, toggleMainMenuReducer),
	...pairActionTypeToReducer(CLOSE_MAIN_MENU, toggleMainMenuReducer),
	...pairActionTypeToReducer(CLOSE_PANE, closePaneReducer),
	...pairActionTypeToReducer(OPEN_PANE, openPaneReducer),
});
